import { Language } from '@contracts/client/Language';
import * as yup from 'yup';

export class LanguageField {
  public static fieldName: string = 'communicationLanguage';
  public static options = Object.values(Language);
  public static validator = yup
    .string()
    .oneOf(LanguageField.options)
    .required();
}
